import React from 'react';
import Translate from '@src/components/Translate/Translate';
import {formatPrice} from '@src/helpers/formatters/prices/formatPrice';
import classnames from '@src/helpers/classnames';
import OrderTotalPaymentsPrice from '@views/orders/fields/payments/OrderTotalPaymentsPrice';
import useFormValue from '@src/hooks/useFormValue';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {IOrderPaymentModel} from '@src/@interfaces/models/Order/IOrderPaymentModel';

export function TableCaption() {
    const {currentValue: payments} = useFormValue<IOrderModel, IOrderPaymentModel[] | undefined>('payments');

    return <OrderTotalPaymentsPrice payments={payments}>{totalPrice => {
        return <Translate
                message="OrderForm.payments.total_amount_is"
                replace={{
                    amount: totalPrice,
                    formattedAmount: formatPrice(totalPrice),
                }}
                tag="caption"
                className={classnames('px-2', {
                    'text-danger': totalPrice < 0,
                })}
        />;
    }}</OrderTotalPaymentsPrice>;
}
